import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { showTokenExpiredAlert, getConfig, authHeader, getCustId, isApiSuccess } from "utils";

// POST subscriber/paymentHistory/ { custId } -> dataList
export const paymentList = createAsyncThunk('payment/list', async ({ navigate }) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'subscriber/paymentHistory/',
            data: { "custId": getCustId() },
            headers: authHeader()
        })
        return res
    } catch (error) {
        return error.response
    }
})

const payment = createSlice({
    name: 'payment',
    initialState: {
        list: [],
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(paymentList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(paymentList.fulfilled, (state, action) => {
            state.loading = false;
            if (isApiSuccess(action?.payload)) {
                state.list = action.payload.data.dataList || [];
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else {
                state.list = []
            }
        });
        builder.addCase(paymentList.rejected, (state) => {
            state.loading = false;
        });
    }
})

export default payment.reducer;
